import React, { useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { login } from "../../redux/apiCalls"
// Styles
import {
   Container,
   Error,
   StyledButton,
   StyledForm,
   StyledInput,
   Wrapper,
} from "./Login.styles"

const Login = () => {
   const [userName, setUserName] = useState("")
   const [password, setPassword] = useState("")
   const dispatch = useDispatch()
   const { error } = useSelector((state) => state.user)

   const handleSubmit = (e) => {
      e.preventDefault()
      login(dispatch, { userName, password })
   }

   console.log(error)
   return (
      <Container>
         <Wrapper>
            <StyledForm onSubmit={handleSubmit}>
               <StyledInput
                  type="text"
                  placeholder="username"
                  onChange={(e) => setUserName(e.target.value)}
               />
               <StyledInput
                  type="password"
                  placeholder="password"
                  onChange={(e) => setPassword(e.target.value)}
               />
               <StyledButton>LOGIN</StyledButton>
               {error && (
                  <Error>
                     {(() => {
                        if (typeof error !== "string") {
                           try {
                              console.debug("Login error value:", error)
                           } catch {}
                        }
                        const msg =
                           typeof error === "string"
                              ? error
                              : typeof error?.message === "string"
                              ? error.message
                              : (() => {
                                   try {
                                      return JSON.stringify(error)
                                   } catch {
                                      return String(error)
                                   }
                                })()
                        return String(msg)
                     })()}
                  </Error>
               )}
            </StyledForm>
         </Wrapper>
      </Container>
   )
}

export default Login
